export const convertMinutesToTime = (
  minutes: number
): { hour: number; min: number; sec: number } => {
  const totalSeconds = Math.floor(minutes * 60);
  const hour = Math.floor(totalSeconds / 3600);
  const min = Math.floor((totalSeconds % 3600) / 60);
  const sec = totalSeconds % 60;

  return { hour, min, sec };
};
